import { withEditableArea } from '@trendkite/ui';
import StorySummaryDisplay from './StorySummaryDisplay';
import EditStorySummaryContainer from './EditStorySummaryContainer';

export default withEditableArea(StorySummaryDisplay, EditStorySummaryContainer);
